<template>
  <article class="">
    <section class="portada">
      <div class="linea">
        <h1>Nuestras Plantas</h1>
      </div>
    </section>
    <section class="lineas">
      <div class="linea1"></div>
      <div class="linea2"></div>
      <div class="linea3"></div>
    </section>
    <section class="descripcion">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-12 col-md-8">
            <p>La ubicación geográfica de las instalaciones es otra característica particular de nuestra compañía dado que el proceso se divide en dos instalaciones: una planta separadora y una planta fraccionadora, conectadas por un ducto de 600 km de longitud que atraviesa cuatro provincias.</p>
            <p><strong>La Planta Separadora</strong> está ubicada en el corazón del yacimiento de gas natural argentino, <strong>Loma La Lata</strong>, provincia del Neuquén. Se abastece por una corriente de gas natural de aproximadamente 40 millones de metros cúbicos estándar por día para alimentar el proceso en el que se retienen líquidos por el equivalente de aproximadamente 5 millones de metros cúbicos por día, retornando el "gas seco" o metano a YPF S.A. que lo inyecta en los sistemas troncales de transporte de gas natural (NEUBA II, CENTRO OESTE Y PACIFICO). Los líquidos retenidos son transportados por un poliducto de 12 pulgadas de diámetro, a través de 600 kilómetros que separan Neuquén de Bahía Blanca, donde se ubica la Planta Fraccionadora.</p>
            <p><strong>La Planta Fraccionadora</strong> se ubica dentro del Polo Petroquímico de <strong>Bahía Blanca</strong>; el más grande del país, aprovechando así la infraestructura de un complejo industrial integrado, un puerto de aguas profundas y la escasa distancia que separa a la planta de su consumidor de etano. En la planta se fraccionan los líquidos, obteniéndose etano, propano, butano y gasolina natural. Además, presenta instalaciones especialmente construidas para el almacenamiento y despacho de propano, butano y gasolina natural.</p>
            <p><strong>Compañía Mega S.A.</strong> cuenta con la ventaja competitiva de tener un extraordinario muelle ubicado sobre el canal de Acceso del Complejo Portuario de Bahía Blanca, único puerto de aguas profundas del país, que permite la exportación de productos en buques de gran porte.</p>
            <img src="./nuestras-plantas.jpg" alt="Planta" class="img-fluid">
          </div>
        </div>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  name: 'nuestrasPlantas'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
img
  margin: 0 auto
  display: block
</style>



// WEBPACK FOOTER //
// src/components/nuestras-plantas/nuestrasPlantas.vue